import React, { FC } from 'react';
import { useLogger } from '@direct-frontend/modules-logger';

import { Button } from '../../Button';
import { Header } from '../../Header';
import { HStack } from '../../Stack';
import { cn } from '../../../lib/css/className/className';
import { TestProps } from '../../../internal/types/testTypes';

import { i18n } from './Header.i18n';
import './Header.css';

export interface DrawerHeaderProps extends TestProps {
    title?: string;
    onCancelClick?: () => void;
    onSaveClick?: () => void;
}

const cls = cn('DrawerHeader');

export const DrawerHeader: FC<DrawerHeaderProps> = function DrawerHeader(props) {
    const { title, onCancelClick, onSaveClick, 'data-testid': dataTestId = 'DrawerHeader' } = props;
    const { LogProvider } = useLogger('DrawerHeader');

    return (
        <LogProvider>
            <HStack justifyContent="space-between" alignItems="center" gap="12">
                <Button
                    color="text-supplementary"
                    size="s"
                    isDisabled={!onCancelClick}
                    className={cls('button', {
                        hidden: !onCancelClick,
                    })}
                    onClick={onCancelClick}
                    data-testid={`${dataTestId}.Cancel`}
                    logNode="CancelButton"
                >
                    {i18n('Отмена')}
                </Button>
                <Header level="h4" isTruncated>
                    {title}
                </Header>
                <Button
                    color="text-supplementary"
                    size="s"
                    isDisabled={!onSaveClick}
                    className={cls('button', {
                        hidden: !onSaveClick,
                    })}
                    onClick={onSaveClick}
                    data-testid={`${dataTestId}.Save`}
                    logNode="SaveButton"
                >
                    {i18n('Готово')}
                </Button>
            </HStack>
        </LogProvider>
    );
};
